const VideoEditorEvents = {
  RESET_PLAYBACK: "V9_EDITOR_RESET_PLAYBACK",
  RENDER_COMPOSITION: "V9_EDITOR_RENDER_COMPOSITION",
  CHANGE_COMPOSITION: "V9_EDITOR_CHANGE_COMPOSITION",
  READY: "V9_EDITOR_READY"
};

export const getRenderCompositionEventMessage = ({
  frameStart,
  resolution,
  composition,
}) =>
  JSON.stringify({
    name: VideoEditorEvents.RENDER_COMPOSITION,
    data: {
      loop: true,
      frameStart,
      resolution,
      composition,
    },
  });
